import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";
import MenuItemsOnePage from "./MenuItemsOnePage";
import ButtonTwo from "../Button/ButtonTwo";

import LogoRic from "../../assets/img/logo/transparent-logo.png";

const HeaderFive = (props) => {
  const { headerClass, isOnePage } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {/* Logo Zoom Animation Style */}
      <style>
        {`
          @keyframes zoomLogo {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }

          .rotating-logo {
            animation: zoomLogo 3s ease-in-out infinite;
            transition: transform 0.3s ease-in-out;
            width: 80px;
            height: auto;
          }

          .rotating-logo-mobile {
            animation: zoomLogo 3s ease-in-out infinite;
            transition: transform 0.3s ease-in-out;
            width: 20px;
            height: auto;
          }
            
      /* NEW BUTTON STYLE */
      .it-btn-theme.red-bg {
        padding: 12px 28px !important;
        font-size: 0.9rem !important;
        font-weight: 600;
        border-radius: 30px;
      }


@keyframes flashZoom {
            0% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(255, 0, 0, 0.7);
            }
            50% {
              transform: scale(1.15);
              box-shadow: 0 0 20px rgba(255, 0, 0, 0.9);
            }
            100% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(255, 0, 0, 0.7);
            }
          }

          .flash-zoom {
            animation: flashZoom 1.5s ease-in-out infinite;
            position: relative;
            z-index: 2;
          }

          /* FIX BUTTON TEXT CUTTING ISSUE */
.it-header-button {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;
}

.it-header-button .it-btn-theme {
  width: auto !important;
  min-width: max-content !important;
  padding: 12px 26px !important;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
  font-size: 14px;
  line-height: 1;
}




          .header-extra-padding {
  padding-left: -60px;
  padding-right: -60px;
}

/* Responsive adjustment */
@media (max-width: 991px) {
  .header-extra-padding {
    padding-left: 20px;
    padding-right: 20px;
  }
}


        `}
      </style>

      <header className={headerClass ? headerClass : ""}>
        <div
          id="header-sticky"
          className={
            isVisible
              ? "it-header-area it-header-ptb it-header-style-3 it-header-style-4 white-bg header-sticky"
              : "it-header-area it-header-ptb it-header-style-3 it-header-style-4 white-bg"
          }
        >
          <div className="container header-extra-padding">
            <div className="p-relative">
              <div className="row align-items-center">
                <div className="col-xl-1 col-6">
                  <div className="it-header-logo">
                    <Link to="/">
                      <img src={LogoRic} alt="RIC Logo" className="rotating-logo" />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-8 d-none d-xl-block">
                  <div className="it-header-main-menu it-main-menu">
                    <nav className="it-menu-content">{!isOnePage ? <MenuItems /> : <MenuItemsOnePage onePageStyle="onePage5" />}</nav>
                  </div>
                </div>
                <div className="col-xl-3 col-6">
                  <div className="it-header-button d-flex align-items-center justify-content-end gap-3">
                    <ButtonTwo btnURL="/registercompany" btnClass="it-btn-theme red-bg d-none d-lg-block" btnText="Register Your Company" />
                    <ButtonTwo
                      btnURL="https://appointments.ricgop.online/#appointment"
                      btnClass="it-btn-theme red-bg d-none d-lg-block flash-zoom"
                      btnText="Book Appointment"
                    />
                  </div>

                  {/* Mobile menu icon */}
                  <div className="it-header-bar d-xl-none">
                    <button className="it-menu-bar" onClick={() => setIsOffCanvasOpen(true)}>
                      <span>
                        <i className="fa-regular fa-bars-sort"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="itoffcanvas__close-btn">
            <button className="close-btn" onClick={() => setIsOffCanvasOpen(false)}>
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoRic} alt="RIC Logo" className="rotating-logo-mobile" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>
              Welcome to RIC, where compassionate care meets advanced cardiovascular expertise. Our dedicated team of specialists is committed
              to providing the highest standard of treatment for your heart health.
            </p>
          </div>
          <div className="it-menu-mobile">
            {!isOnePage ? <MenuItems isMobileMenu /> : <MenuItemsOnePage onePageStyle="onePage5" isMobileMenu />}
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get Your Appointment</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="mailto:hello@yourmail.com">info@ricgop.online</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">+92-51-9281111-9</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a href="https://www.google.com/maps/@37.4801311,22.8928877,3z" target="_blank" rel="noreferrer">
                  Rawal Road, Rawalpindi, Pakistan
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div className="body-overlay apply" onClick={() => setIsOffCanvasOpen(false)}></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderFive;
